// extracted by mini-css-extract-plugin
export default {"root":"IconTextFile_root__Y8eEk"};